import { FloatingPanelSeparator } from "@babackapp/ui/components/floating-panel";
import { EditorContent } from "@tiptap/react";
import { RefreshCw } from "lucide-react";
import PanelBlockAlignment from "../../lib/panel/panel-block-alignment";
import PanelBlockFont from "../../lib/panel/panel-block-font";
import PanelContainer from "../../lib/panel/panel-container";
import PanelContent from "../../lib/panel/panel-content";
import PanelTranslationState from "../../lib/panel/panel-translation-state";
import { useParagraphEditor } from "../paragraph/email-panel-content";
import { EmailPanelToolbar } from "../paragraph/email-panel-toolbar";
import type { DynamicTextBlockProps } from "./types";

function DynamicTextPanelWorkflowContent() {
  const editor = useParagraphEditor();

  return (
    <>
      <PanelContent title="Contenu">
        <div className="space-y-2">
          <EmailPanelToolbar editor={editor} />
          <EditorContent editor={editor} />
        </div>
      </PanelContent>
      <FloatingPanelSeparator />
      <PanelBlockFont />
      <PanelBlockAlignment />
      <PanelTranslationState mode="translatable" portal />
    </>
  );
}

function DynamicTextPanelTemplateContent() {
  return (
    <PanelContent title="Contenu dynamique">
      <div className="flex items-start gap-3 rounded-md bg-muted/50 p-3">
        <RefreshCw className="mt-0.5 h-4 w-4 shrink-0 text-muted-foreground" />
        <p className="text-xs text-muted-foreground">
          Le contenu de ce bloc est défini dans chaque workflow.
        </p>
      </div>
    </PanelContent>
  );
}

export function DynamicTextEmailPanelRenderer(
  blockProps: DynamicTextBlockProps,
) {
  const isWorkflowMode = blockProps.editorMode === "workflowCustom";

  return (
    <PanelContainer blockProps={blockProps}>
      {isWorkflowMode ? (
        <DynamicTextPanelWorkflowContent />
      ) : (
        <DynamicTextPanelTemplateContent />
      )}
    </PanelContainer>
  );
}
